module.exports = __webpack_public_path__ + "static/media/cancel-package_5.4406ae66.png";